import React, { useEffect, useState } from 'react';
import { Handles, Rail, Slider, Ticks, Tracks } from 'react-compound-slider';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IOrderDetails } from '../../../../models/order';
import { Handle, Tick, Track } from '../../../common/slider-components';

const sliderStyle: React.CSSProperties = {
    marginTop: '15px',
    position: 'relative',
    width: '100%',
};

const railStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: 10,
    borderRadius: 5,
    cursor: 'default',
    backgroundColor: 'lightGrey',
};

interface IPizzaTrackerProps {
    order: IOrderDetails;
}

export const PizzaTracker = ({
    order,
}: //reorder
IPizzaTrackerProps) => {
    const intl = useIntl();
    const [activeTick, setActiveTick] = useState(0);
    const customs = [
        'Submitted',
        'Received',
        'Planning',
        'Production',
        'Testing',
        'Shipped',
        'Delivered',
    ];
    const nonCustoms = [
        'Submitted',
        'Received',
        'Processing',
        'Shipped',
        'Delivered',
    ];
    //ATTN: bug 102813
    //CQ OrderStatus is sometimes unreliable, if we don't have the data we need to just display a standard pizza tracker
    const isCustom = order!.isCustom && order!.cqOrderStatus ? true : false;
    useEffect(() => {
        if (isCustom) {
            if (customs.indexOf(order.cqOrderStatus) > 0) {
                setActiveTick(customs.indexOf(order.cqOrderStatus));
            }
        } else {
            if (nonCustoms.indexOf(order.orderStatus) > 0) {
                setActiveTick(nonCustoms.indexOf(order.orderStatus));
            }
        }
        //leaving this to monitor data easily in higher environments
        console.log(
            'activeTick:',
            activeTick,
            'order.orderStatus:',
            order.orderStatus,
            'isCustom:',
            isCustom
        );
    }, [order.orderStatus, activeTick]);
    const formatTicks = (d: number) => {
        if (isCustom) {
            if (d > 6) {
                return '';
            }
            //TODO: Unify Testing and Final Testing to have the same key.
            if (d === 4) {
                return intl.formatMessage({
                    id: 'Final Testing',
                    defaultMessage: 'Final Testing',
                });
            }
            return intl.formatMessage({
                id: customs[d],
                defaultMessage: customs[d],
            });
        } else {
            if (d > 4) {
                return '';
            }
            return intl.formatMessage({
                id: nonCustoms[d],
                defaultMessage: nonCustoms[d],
            });
        }
    };

    const getStatusIdx = (status: string) => {
        if (isCustom) {
            if (status === 'Submitted') return 0;
            if (status === 'Received') return 1;
            if (status === 'Planning') return 2;
            if (status === 'Production') return 3;
            if (status === 'Testing') return 4;
            if (status === 'Shipped') return 5;
            if (status === 'Delivered') return 6;
            return 0;
        } else {
            if (status === 'Submitted') return 0;
            if (status === 'Received') return 1;
            if (status === 'Processing') return 2;
            if (status === 'Shipped') return 3;
            if (status === 'Delivered') return 4;
            return 0;
        }
    };
    return (
        <>
            {order.orderStatus !== 'Scheduled' && (
                <div className="row" style={{ paddingBottom: '40px' }}>
                    <div className="col-md-12">
                        <Slider
                            mode={1}
                            step={1}
                            domain={isCustom ? [0, 6] : [0, 4]}
                            disabled={true}
                            rootStyle={sliderStyle}
                            values={
                                isCustom
                                    ? [getStatusIdx(order.cqOrderStatus)]
                                    : [getStatusIdx(order.orderStatus)]
                            }
                        >
                            <div>
                                <label className="control-label">
                                    <FormattedMessage id="Status" />
                                </label>
                            </div>
                            <Rail>
                                {({ getRailProps }) => (
                                    <div
                                        style={railStyle}
                                        {...getRailProps()}
                                    />
                                )}
                            </Rail>
                            <Handles>
                                {({ handles, getHandleProps }) => (
                                    <div className="slider-handles">
                                        {handles.map((handle) => (
                                            <Handle
                                                key={handle.id}
                                                handle={handle}
                                                domain={
                                                    isCustom ? [0, 6] : [0, 4]
                                                }
                                                getHandleProps={getHandleProps}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Handles>
                            <Tracks right={false}>
                                {({ tracks, getTrackProps }) => (
                                    <div className="slider-tracks">
                                        {tracks.map(
                                            ({ id, source, target }) => (
                                                <Track
                                                    key={id}
                                                    source={source}
                                                    target={target}
                                                    getTrackProps={
                                                        getTrackProps
                                                    }
                                                />
                                            )
                                        )}
                                    </div>
                                )}
                            </Tracks>
                            <Ticks
                                values={
                                    isCustom
                                        ? [0, 1, 2, 3, 4, 5, 6]
                                        : [0, 1, 2, 3, 4]
                                }
                            >
                                {({ ticks }) => (
                                    <div className="slider-ticks">
                                        {ticks.map((tick) => (
                                            <Tick
                                                key={tick.id}
                                                format={formatTicks}
                                                tick={tick}
                                                count={ticks.length}
                                                activeTick={activeTick}
                                            />
                                        ))}
                                    </div>
                                )}
                            </Ticks>
                        </Slider>
                    </div>
                </div>
            )}
            <hr />
        </>
    );
};

export default PizzaTracker;
